import { Box } from '@zoopla-eng/zds-components/box';
import { styled } from '@zoopla-eng/zds-components/themes';
import NewHomesHeroImageLarge from '../components/NewHomesHeroImage/assets/hero-image-large.jpg';

export const BoxBleed = styled(Box, {
    width: '100%',
    '@S200': {
        margin: '0 -$S400'
    },
    '@M100': {
        margin: 'initial'
    }
});

export const HeroWrapper = styled('div', {
    '@M100': {
        backgroundImage: `url(${NewHomesHeroImageLarge})`,
        backgroundSize: 'cover',
        borderRadius: '$600',
        backgroundColor: '$graphicBackgroundAccentDark',
        padding: '$M100'
    }
});

export const ContentWrapper = styled('div', {
    backgroundColor: 'white',
    borderRadius: '$500',
    position: 'relative',
    padding: '$S400 $S400 0 $S400',
    marginLeft: '-$S400',
    marginRight: '-$S400',
    '@M100': {
        boxShadow: '$100',
        padding: '$S400',
        marginLeft: '0',
        marginRight: '0'
    }
});
